var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "attribute-context" } },
    [
      _c("a-auto-complete", {
        staticStyle: { width: "100%" },
        attrs: {
          placeholder: _vm.$t("chatbotv2.choseAttribute"),
          dataSource: _vm.dataSource,
        },
        on: {
          select: function ($event) {
            return _vm.$emit("selected", _vm.selected)
          },
          search: function (x) {
            return (this$1.query = x)
          },
        },
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }